enum MailboxType {
    UserMailbox,
    GroupMailbox,
}

export default MailboxType;
